//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AutomationStatistics",
  props: {
    statistics: {
      type: Object,
      default: () => ({})
    },
    status: {
      type: String,
      default: ""
    }
  },
  computed: {
    emptyStatistics() {
      return isEmpty(this.statistics);
    },
    notSentYet() {
      return this.status === "sent";
    },
    clicks() {
      return this.statistics.click;
    },
    send() {
      return this.statistics.send;
    },
    open() {
      return this.statistics.open;
    },
    delivery() {
      return this.statistics.delivery;
    }
  }
});